var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import * as dayjs from 'dayjs';
import css from './style.pcss';
import LocalisationWhiteIcon from "./images/ic_localisation_white.svg";
var RTLWiederfraesch = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLWiederfraesch, _LitElement);
  function RTLWiederfraesch() {
    var _this;
    _classCallCheck(this, RTLWiederfraesch);
    _this = _callSuper(this, RTLWiederfraesch);
    _this.assetsUrl = 'https://rtl-sites-assets.rtl.lu';
    if (window.rtlsites) {
      _this.assetsUrl = window.rtlsites.config.assetsUrl;
    }
    return _this;
  }
  _createClass(RTLWiederfraesch, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLWiederfraesch.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      this._apiUrl = `https://api-gate.rtl.lu/meteo/weatherfrog`;
      fetch(this._apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.data == undefined) return html(_t || (_t = _`<div></div>`));
      return html(_t2 || (_t2 = _`
        <div class="${0}">
            <section class="rtl-wiederfraesch__wrapper" style="background-image: url('${0}'); background-repeat: no-repeat; background-position: 50% 60%; background-size: cover;">
                <div class="rtl-wiederfraesch__container">
                    <style>${0}</style>
                    <div class="rtl-wiederfraesch__content">
                        <div class="rtl-wiederfraesch__title-container">
                            <span class="rtl-wiederfraesch__title">De Wiederfräsch</span>
                        </div>

                        <div class="rtl-wiederfraesch__weather-container">
                            <div class="rtl-wiederfraesch__weather-content">
                                <div class="rtl-wiederfraesch__data-icon"><img src="${0}" class="rtl-wiederfraesch__icon"></div>

                                <div class="rtl-wiederfraesch__data-container">
                                    <div class="rtl-wiederfraesch__data-title">D'Situatioun</div>
                                    <div class="rtl-wiederfraesch__data-text">${0}</div>
                                </div>
                            </div>

                            <div class="rtl-wiederfraesch__weather-content">
                                <div class="rtl-wiederfraesch__data-icon">${0}</div>

                                <div class="rtl-wiederfraesch__data-container">
                                    <div class="rtl-wiederfraesch__data-title">D'Previsiounen</div>
                                    <div class="rtl-wiederfraesch__data-text">${0}</div>
                                </div>
                            </div>

                            <div class="rtl-wiederfraesch__weather-content">
                                <div class="rtl-wiederfraesch__data-icon">${0}</div>

                                <div class="rtl-wiederfraesch__data-container">
                                    <div class="rtl-wiederfraesch__data-title">Aussiichten</div>
                                    <div class="rtl-wiederfraesch__data-text">${0}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        `), this.isMeteoPage === true ? 'rtl-wiederfraesch' : 'rtl-wiederfraesch--article', this.data.background, css, LocalisationWhiteIcon, this.data.situation, this.data.previsionIcon ? html(_t3 || (_t3 = _`<img src="${0}/images/weather/icons_white_svg/${0}.svg" class="rtl-wiederfraesch__icon">`), this.assetsUrl, this.data.previsionIcon) : ``, this.data.prevision, this.data.forecastIcon ? html(_t4 || (_t4 = _`<img src="${0}/images/weather/icons_white_svg/${0}.svg" class="rtl-wiederfraesch__icon">`), this.assetsUrl, this.data.forecastIcon) : ``, this.data.forecast);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        isMeteoPage: {
          type: Boolean
        }
      };
    }
  }]);
  return RTLWiederfraesch;
}(LitElement);
export { RTLWiederfraesch as default };
window.customElements.define('rtl-wiederfraesch', RTLWiederfraesch);